import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PagesEventService, Url } from "src/app/common";
import { User, UserAuth } from "src/app/common/user-auth";
import { GroupUser } from "../models/group-user.model";
import { Ticket } from "../models/ticket.model";
import { TicketService } from "../services/ticket.service";

@Component({
  selector: 'app-ticket-group-index',
  templateUrl: '../views/ticket-group.component.html',
  styleUrls: ['../styles/style.css']
})
export class TicketGroupComponent implements OnInit {
  url = Url;
  userAuth: User = UserAuth.get();
  ticket = new Ticket();
  groupUser = new GroupUser();
  onSubmit=null;
  ticketGroupName;
  ticketCategoryName;
  deleteGroupID;
  displayDeleteGroup = false;
  displayAddNewSubcategory = false;
  addNewSubcategoryCategoryID = null;
  newSubcategory = null;
  ticketsGroups = [];
  data = [];
  usersData = [];
  categoryData = [];
  categorySkynetTicketData = [];
  categoryItTicketData = [];
  logs=[];

  permisions = {
    EDIT_TICKET_MANAGEMENT: this.userAuth.getAction('EDIT_TICKET_MANAGEMENT')
  };

  constructor(private pagesEventService: PagesEventService,
              private router: Router,
              public ticketService: TicketService) {
  }

  ngOnInit(): void {
    this.ticket.user_id = this.userAuth.id;
    this.ticket.status = 'Processing';
    this.getAllTicketsGroup();
    this.getAllUsers();
    this.getUserGroups();
    this.getAllTicketsCategory();
    this.getLogs();
    this.setBreadCrumb();
  }

  setBreadCrumb() {
    var array=[{ name: 'Home', routerLink: '/' },{ name: 'Ticket management', routerLink: '/ticket/group' }];
    this.pagesEventService.setBreadcrumbByKeys(array);
  }

  getAllTicketsCategory() {
    this.ticketService.getAllTicketsCategory({ type: this.ticket.type }).subscribe((response) => {
      this.categoryData = response.TicketsCategory;
      this.categorySkynetTicketData = this.categoryData.filter(cat => cat.type === 'Skynet-Ticket');
      this.categoryItTicketData = this.categoryData.filter(cat => cat.type === 'IT-Ticket');
    });
  }

  getUserGroups() {
    this.ticketService.getAllTicketsUsersGroups().subscribe((response) => {
      this.usersData = response.TicketsGroupUsers;
    });
  }

  getAllUsers() {
    this.ticketService.getEmployees().subscribe((response) => {
      this.data = response.Employees;
      this.data.forEach(element => {
        element.user_id = element.id;
      });
    });
  }

  getAllTicketsGroup() {
    this.ticketService.getAllTicketsGroups().subscribe((response) => {
      response.TicketsGroup.forEach(element => {
        element.users.forEach(user => {
          user.id={id:user.id} || user.push({id:null});
        });
      });
      this.ticketsGroups = response.TicketsGroup;
      this.ticketsGroups.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getLogs() {
    this.ticketService.getAllLogs({subjectTypes:["tickets_group","tickets_category","tickets_group_users"]}).subscribe((response) => {
      if(response.Status == 200) {
        this.logs=response.Logs;
      }
    });
  }

  submit(value) {
    this.ticketService.createTicketGroup({ name: this.ticketGroupName }).subscribe((response) => {
      this.ticketGroupName = '';
      this.getAllTicketsGroup();
    });
  }

  selectedUser(groups:Array<{id:number,name:string}>, group_id) {
    this.ticketService.saveGroupUser({groups:groups,group_id:group_id}).subscribe((response) => { });
  }

  prepare(value, group_id) {
    value.forEach(element => {
      this.groupUser.user_id = element.user_id;
      this.groupUser.name = element.name;
      this.groupUser.group_id = group_id;
      this.saveUser();
    });
  }

  saveUser() {
    this.ticketService.saveGroupUser(this.groupUser).subscribe((response) => {
      this.getUserGroups();
      this.getAllTicketsGroup();
    });
  }

  removeUserGroup(userGroupID) {
    this.ticketService.deleteGroupUser({ id: userGroupID }).subscribe((response) => {
      this.getUserGroups();
    });
  }

  deleteGroup(groupID) {
    this.deleteGroupID = groupID;
    this.displayDeleteGroup = true;
  }

  confirmDeleteGroup() {
    this.ticketService.deleteSingleGroup({ id: this.deleteGroupID }).subscribe((response) => {
      this.getAllTicketsGroup();
      this.displayDeleteGroup = false;
    });
  }

  declineDeleteGroup() {
    this.deleteGroupID = null;
    this.displayDeleteGroup = false;
  }

  submitCategory(e, type) {
    this.ticketService.createNewCategory({ name: this.ticketCategoryName, type: type }).subscribe((response) => {
      this.ticketCategoryName = '';
      this.getAllTicketsCategory();
    });
  }

  removeCategory(id) {
    this.ticketService.deleteSingleCategory({ id: id }).subscribe((response) => {
      this.getAllTicketsCategory();
    });
  }

  removeSubcategory(id) {
    this.ticketService.deleteSingleSubcategory({ id: id }).subscribe((response) => {
      this.getAllTicketsCategory();
    });
  }

  addSubcategory(id) {
    this.displayAddNewSubcategory = true;
    this.addNewSubcategoryCategoryID = id;
  }

  confirmAddNewSubcategory() {
    this.ticketService.addSubcategory({ category_id: this.addNewSubcategoryCategoryID, name: this.newSubcategory }).subscribe((response) => {
      this.getAllTicketsCategory();
      this.declineAddNewSubcategory();
    });
  }

  declineAddNewSubcategory() {
    this.addNewSubcategoryCategoryID = null;
    this.newSubcategory = null;
    this.displayAddNewSubcategory = false;
  }

  onCategoryChanged(categoryGroups:Array<{id:number,name:string}>, categoryId) {
    this.ticketService.createCategoryGroups({groups:categoryGroups.map(group => group.id),category_id:categoryId}).subscribe((response) => { });
  }

  onSubcategoryChanged(categoryGroups:Array<{id:number,name:string}>, categoryId) {
    this.ticketService.createSubcategoryCategory({groups:categoryGroups,category_id:categoryId}).subscribe((response) => { });
  }


}
